<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>

<div class="page">
    <div class="page_header">
        <h1 class="page_title">Critérios de Retorno Financeiro</h1>
        <div class="page_action" style="gap: 20px">
            <a href="javascript:void(0);" (click)="newCriteria()" class="page_action_excel btn btn-warning" type="button">
                <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
                <span class="ml-2 font-weight-normal">{{'newCriteria' | translate}}</span>
            </a>
        </div>
    </div>
    <div class="page_padding">
        <div class="page_filter mb-4">
            <div class="input-material custom__input modal_text_input" style="max-width: 200px;">
                <select id="iptType" class="form-control" name="retornoType" [(ngModel)]="selectedCriteria.remunerationId" required>
                    <option value="">Selecione</option> 
                    <option *ngFor="let remuneration of remunerations" [value]="remuneration.id">{{ remuneration.name }}</option>
                  </select>
                <label for="iptType" class="mb-0 mr-3">Tipo de retorno</label>
            </div>
            

            <div class="input-material">
                <input id="search" class="form-control" type="text" [(ngModel)]="searchText" required>
                <label for="search">
                    <svg-icon src="assets/svg/search.svg"></svg-icon>
                    Busca
                </label>
            </div>
            

            <div class="page_filter_action" style="max-width: 109px;">
                <a href="javascript:void(0)"
                   (click)="search()"
                   class="btn btn-block btn-lg btn-primary btn-search"
                   style="font-weight: normal;" type="button">Buscar</a>
            </div>
        </div>
        
        <p class="aviso">*Para conversão dos ganhos em sustentabilidade para CO2eq = Menu - Sustentabilidade<br>
            Referência para o cálculo do critério de sustentabilidade, baseando-se na redução de emissões geradas de CO2eq.</p>
        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                    <tr>
                        <th scope="col" class="w-10"></th>
                        <th scope="col">Status</th>
                        <th scope="col">Tipo de retorno</th>
                        <th scope="col">Valor mínimo</th>
                        <th scope="col">Valor máximo</th>
                        <th scope="col">Pontos</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let criteria of criteriaList">
                        <td style="width: 150px">
                            <div class="d-flex justify-content-center" style="gap: 15px">
                                <svg-icon class="is-cursor" src="assets/svg/edit.svg" (click)="editCriteria(criteria)"></svg-icon>
                                <svg-icon class="is-cursor" src="assets/svg/close-circle.svg" (click)="deleteCriteria(criteria.id)"></svg-icon>
                            </div>
                        </td>
                        <td>{{ criteria.scoreLevelName }}</td>
                        <td>{{ criteria.remunerationName }}</td>
                        <td>{{ criteria.minValue }}</td>
                        <td>{{ criteria.maxValue }}</td>
                        <td>{{ criteria.points }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Modal de Criação de Critério -->
<div class="modal-custom modal fade" id="modalCriteria" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 560px" role="document">
        <div class="modal-content modal-user">
            <div class="modal-header">
                <h2 class="modal-user_title">Critérios de Retorno Financeiro</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close" (click)="closeModal('modalCriteria')">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-user_body">
                <div class="modal-user_card">
                    <fieldset class="custom__form" autocomplete="off">
                        <div class="row">
                            <div class="col-xs-12 col-md-12">
                                <div class="row">
                                    <div class="col-12 col-md-12">
                                        <div class="input-material custom__input modal_text_input">
                                            <select id="iptType" class="form-control" name="retornoType" [(ngModel)]="selectedCriteria.remunerationId" required>
                                                <option value="undefined" selected>Selecione</option>
                                                <option *ngFor="let remuneration of remunerations" [value]="remuneration.id">{{remuneration.name}}</option>
                                            </select>
                                            <label for="iptType" class="mb-0 mr-3">Tipo de retorno</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="input-material custom__input modal_text_input">
                                            <input id="iptValueMin" class="form-control" [(ngModel)]="selectedCriteria.minValue" name="valueMin" type="text" required />
                                            <label for="iptValueMin">Valor mínimo</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="input-material custom__input modal_text_input">
                                            <input id="iptValuemax" class="form-control" [(ngModel)]="selectedCriteria.maxValue" name="valueMax" type="text" required />
                                            <label for="iptValuemax">Valor máximo</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="input-material custom__input modal_text_input">
                                            <input id="iptPoints" class="form-control" [(ngModel)]="selectedCriteria.points" name="points" type="text" required />
                                            <label for="iptPoints">Pontos</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="input-material custom__input modal_text_input">
                                          <select id="iptStatus" class="form-control" name="type" [(ngModel)]="selectedCriteria.scoreLevelId" required>
                                            <option value="undefined" selected>Selecione</option>
                                            <option *ngFor="let scoreLevel of scoreLevels" [value]="scoreLevel.id">
                                              {{ scoreLevel.levelName }}
                                            </option>
                                          </select>
                                          <label for="iptStatus" class="mb-0 mr-3">Status</label>
                                        </div>
                                      </div>
                                    <div class="col-12">
                                        <a class="btn btn-block btn-lg btn-primary text-warning" href="javascript:void('save');" (click)="saveCriteria()">
                                            SALVAR
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>
